import React, { useState } from 'react'
import { Stack, Button, Divider } from '@mui/material';
import { useParams } from 'react-router-dom';
import WarehouseInventoryListContainer from './WarehouseInventoryListContainer';
import ProductImportModal from '../../components/inventorymng/products/ProductImportModal';
import ProductExportModal from '../../components/inventorymng/products/ProductExportModal';
import ProductDisposalModal from '../../components/inventorymng/products/ProductDisposalModal';
import ProductMoveModal from '../../components/inventorymng/products/ProductMoveModal';


const InventoryProductsContainer = () => {
    const { whUuid } = useParams();
    const [type, setType] = useState(null);
    const [open, setOpen] = useState(false);
    const handleOpen = (param) => {
        setType(param);
        setOpen(true);

    };
    const handleClose = () => {
        setOpen(false);
        setType(null);
    };

    return (
        <div>
            <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={2} sx={{ p: 1 }}>
                <Button variant="contained" color="secondary" onClick={() => handleOpen('import')}>입고</Button>
                <Button variant="contained" color="primary" onClick={() => handleOpen('export')}>출고</Button>
                <Button variant="contained" color="info" onClick={() => handleOpen('disposal')}>폐기</Button>
                <Button variant="outlined" color="warning" onClick={() => handleOpen('move')}>이동</Button>
            </Stack>
            <Divider />
            <WarehouseInventoryListContainer />

            {open && type === 'import' && (<ProductImportModal open={open} handleClose={handleClose} whUuid={whUuid} />)}
            {open && type === 'export' && (<ProductExportModal open={open} handleClose={handleClose} whUuid={whUuid} />)}
            {open && type === 'disposal' && (<ProductDisposalModal open={open} handleClose={handleClose} whUuid={whUuid} />)}
            {open && type === 'move' && (<ProductMoveModal open={open} handleClose={handleClose} whUuid={whUuid} />)}
        </div>
    )
}

export default InventoryProductsContainer
